import { render, staticRenderFns } from "./BarcodeGenerator.vue?vue&type=template&id=4fb5068c&scoped=true"
import script from "./BarcodeGenerator.vue?vue&type=script&lang=js"
export * from "./BarcodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./BarcodeGenerator.vue?vue&type=style&index=0&id=4fb5068c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5068c",
  null
  
)

export default component.exports